import i18next from 'i18next';
import icon from '../images/example-push.jpg';

export function sendNotification() {
  const message = {
    title: i18next.t('LIMITED_OFFER'),
    body: i18next.t('REGISTER_AND_MANAGE'),
    link: i18next.t('LINK_REGISTER'),
    actions: [{
      action: 0,
      title: i18next.t('REGISTER_NOW')
    }, {
      action: 1,
      title: i18next.t('READ_MORE_PUSH')
    }],
    data: {
      buttons: {
        0: {
          action: 'open',
          url: i18next.t('LINK_REGISTER')
        },
        1: {
          action: 'open',
          url: process.env.REFERRAL_LINK
        }
      }
    }
  };

  const notification = new Notification(message.title, {
    icon,
    body: message.body,
    data: message.data,
    // actions: message.actions
  });

  notification.onclick = function () {
    window.open(message.link);
    notification.close();
  };
}